var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card-maker',{attrs:{"infos":_vm.infos,"cardColor":_vm.cardColor,"stripColor":_vm.stripColor,"buttonColor":_vm.buttonColor,"textColor":_vm.textColor,"numberShow":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }